import { FieldValues, Path } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { SegmentedControlField } from '../SegmentedControlField';

type LanguagePropsType<T extends FieldValues> = {
  fieldName: Path<T>;
};

export const Language = <T extends FieldValues>({
  fieldName,
}: LanguagePropsType<T>): React.ReactElement => {
  const { t } = useTranslation();

  return (
    <SegmentedControlField<T>
      fieldName={fieldName}
      label={t('REPORTS.MAILING_FORM.LANGUAGE')}
      options={[
        { value: 'DE', label: t('REPORTS.ENUMS.LOCALE.DE') },
        { value: 'EN', label: t('REPORTS.ENUMS.LOCALE.EN') },
      ]}
    />
  );
};
